import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { NextStepList } from '@/components/molecules';
import { consultationAssurance, consultationSteps } from '@/content/consultation';

/**
 * The four steps a consultation request goes through, headed.
 *
 * The reassurance rail that sits beside the form, extracted from the band on
 * /contact so the page at `/free-import-advice` shows the same four steps
 * rather than its own retelling of them. It is the half of the band that is
 * actually reusable: the grid, the stickiness and the `Section` belong to
 * whichever page is arranging them, and this is just the content.
 *
 * An h3 by default and not configurable. In both arrangements there is an h2
 * above it — the band's `SectionHeading` on /contact, the form's own title on
 * the dedicated page — so h3 is the correct level in both, and a level prop
 * would only be an invitation to get the document outline wrong.
 *
 * No state, no layout decisions, nothing read from the router.
 */
export function ConsultationNextSteps() {
  return (
    <Stack spacing={6}>
      <Stack spacing={2}>
        <Typography variant="overline" sx={{ color: 'primary.main' }}>
          {consultationAssurance.eyebrow}
        </Typography>
        <Typography variant="h5" component="h3">
          {consultationAssurance.title}
        </Typography>
      </Stack>
      <NextStepList steps={consultationSteps} />
    </Stack>
  );
}
